module.exports = __webpack_public_path__ + "media/images/icons/audible-podcast-lg-2f53b3d7d2e1480ff6e7de9c8a282198.svg";